<template>
  <component
    :is="clickable ? 'button' : 'span'"
    class="ruolo-mantra"
    :class="['ruolo-mantra' + mantraId, { outlined, small, 'is-clickable': clickable }]"
    :type="clickable ? 'button' : null"
    :disabled="clickable ? disabled : null"
    :aria-pressed="clickable ? !outlined : null"
    :title="ruolo.descr"
    @click="handleClick"
  >{{ ruolo.label }}</component>
</template>

<script>
import Constants from "../../js/constants";

export default {
  name: "ruolo-mantra",
  props: {
    mantraId: { type: String, required: true },
    outlined: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
  },
  computed: {
    ruolo() {
      return Constants.RUOLI_MANTRA[this.mantraId] || { label: "-", descr: "" };
    },
    clickable() {
      return !!this.$listeners.click;
    },
  },
  methods: {
    handleClick(event) {
      if (!this.clickable) return;
      event.stopPropagation();
      if (!this.disabled) this.$emit("click", this.mantraId);
    },
  },
};
</script>

<style scoped>
.ruolo-mantra.small {
    flex: 0 0 auto;
    font-size: 8px;
    line-height: 1;
    padding: 1px 3px;
}
.ruolo-mantra {
  padding: 1px 5px;
}
.is-clickable {
  cursor: pointer;
}
.is-clickable:hover:not(:disabled) {
  opacity: 0.7;
}
.is-clickable:focus-visible {
  outline: 2px solid var(--v-secondary-base);
  outline-offset: 2px;
}
.is-clickable:disabled {
  cursor: default;
  opacity: 0.5;
}
</style>
